import { hexToRgb } from "@material-ui/core";
import { subtitleLandingLight } from "assets/jss/material-kit-pro-react";
import { blackColor } from "assets/jss/material-kit-pro-react";
import { subtitleLandingBold } from "assets/jss/material-kit-pro-react";

const style = (theme) => ({
  cardTitle: {
    ...subtitleLandingLight,
  },
  img: {
    width: "30px",
    height: "30px",
    overflow: "hidden",
    borderRadius: "50%",
    marginRight: "5px",
    boxShadow:
      "0 5px 15px -8px rgba(" +
      hexToRgb(blackColor) +
      ", 0.24), 0 8px 10px -5px rgba(" +
      hexToRgb(blackColor) +
      ", 0.2)",
  },
  showMoreOrLess: {
    ...subtitleLandingLight,
    cursor: "pointer",
    color: blackColor,
    marginTop: "10px",
    textDecoration: "underline",
  },
  authorText: {
    ...subtitleLandingBold,
    cursor: "pointer",
    color: blackColor,
  },
});

export default style;
